import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=6b19a52f&scoped=true&ts=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"

import "./ForgotPasswordPage.vue?vue&type=style&index=0&id=6b19a52f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b19a52f"]])

export default __exports__